/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createFareFromDiscriminatorValue, createProblemDetailsFromDiscriminatorValue, createStagingFareFromDiscriminatorValue, type Fare, type ProblemDetails, type StagingFare } from '../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /StagingFare/InsertSelectedFare
 */
export interface InsertSelectedFareRequestBuilder extends BaseRequestBuilder<InsertSelectedFareRequestBuilder> {
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<Fare[]>}
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 401 status code
     * @throws {ProblemDetails} error when the service returns a 403 status code
     * @throws {StagingFare} error when the service returns a 422 status code
     */
     post(body: number[], requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<Fare[] | undefined>;
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: number[], requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const InsertSelectedFareRequestBuilderUriTemplate = "{+baseurl}/StagingFare/InsertSelectedFare";
/**
 * Metadata for all the requests in the request builder.
 */
export const InsertSelectedFareRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: InsertSelectedFareRequestBuilderUriTemplate,
        responseBodyContentType: "text/plain;q=0.9",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            401: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            422: createStagingFareFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendCollection",
        responseBodyFactory:  createFareFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestInformationContentSetMethod: "setContentFromScalar",
    },
};
/* tslint:enable */
/* eslint-enable */
